import React from 'react';
import { Navigate, RouteProps, Outlet } from 'react-router-dom';
import AuthenticatedPages from './AuthenticatedPages';

type GuardedRouteProps = RouteProps & {
  /** if is allow user would enter to the route normally, otherSide will redirected to `redirectPath` */
  isAllowed: boolean;
  /**
   * path to been redirected if the user is not allowed,
   * @default '/login'
   */
  redirectPath?: string;
  children?: JSX.Element;
};

const GuardedRoute = ({
  isAllowed,
  redirectPath = '/',
  children,
}: GuardedRouteProps) => {
  if (!isAllowed) {
    // eslint-disable-next-line no-console
    console.log(
      'GuardedRoute: isAllowed',
      isAllowed,
      'redirectPath',
      redirectPath
    );
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <AuthenticatedPages>{children ? children : <Outlet />}</AuthenticatedPages>
  );
};
export default GuardedRoute;
